import { createCrudActions } from '../utils/crudGenerator';

const formatPlacards = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchPlacards,
    create: createPlacard,
    update: updatePlacard,
    delete: deletePlacards
} = createCrudActions('PLACARD', "Cartel", formatPlacards);